import React, { Component } from 'react';
import ImageMapper from 'react-img-mapper';
import ReactTooltip from 'react-tooltip';
import {Modal, ModalBody, ModalFooter} from 'reactstrap';
import { Panel } from '../panel/panel';
import Services from '../../services/service';
import { BASE_URL } from '../../config/constants';

class LayoutMapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      layoutLoading: true,
      selectedLayout: null,
      layoutId: props.selectedLayout,
      assetId: props.assetId,
      dataAsset: null,
      mapAreas: [],
      hoveredArea: null,
      // msg: '',
      error: false,
      zoom: 1000,
      canClick: false,
      showModalDetail: false,
    };
    this.initialState = this.state;
    this.minWidth = 400;
    this.zoomWidth = 100;
  }

  componentDidMount() {
    this.getLayoutAssetCoordinates(this.state.layoutId, this.state.assetId);
  }

  componentDidUpdate(prevProps){
    const { selectedLayout, assetId } = this.props;
    if((selectedLayout !== prevProps.selectedLayout) || (assetId !== prevProps.assetId)){
      this.setState({layoutId: selectedLayout, assetId},
        this.getLayoutAssetCoordinates(selectedLayout, assetId)
      );
    }
  }

  getLayoutAssetCoordinates = (layoutZoneId, assetId) => {
    const config = {
      params: {
        layoutZoneId,
        assetId: assetId ? assetId : '',
      }
    }

    if(this.props.token){
      config.headers = {
        'Authorization': 'Bearer ' + this.props.token
      }
    }

    Services.getLayoutAssetCoordinates(config)
      .then(res => {
        // console.log('mapAreas', res.assetData);
        this.setState({ mapAreas: res.assetData, selectedLayout: res },
          () => setTimeout(() => {
            if(this.props.setLoading){
              this.props.setLoading(false);
            }
            this.setState({layoutLoading: false});
          }, 500)  
        );
      })
      .catch(err => {
        console.log(err);
        this.setState({error: true});
      });
  }

  getDataAsset = (assetId) => {
    const param = { params: { id: assetId } };
    Services.getAssetDetail(param)
    .then(res => {
      this.setState({dataAsset: res});
    })
    .catch(err => console.log(err));
  };
  
  toggleModalDetail = (assetId) => {
    if(assetId){
      this.getDataAsset(assetId);
    }
    this.setState({showModalDetail: !this.state.showModalDetail});
  }

  renderModalDetail = () => {
    const { dataAsset, showModalDetail } = this.state;
    return (
      <Modal isOpen={showModalDetail} toggle={() => this.toggleModalDetail()} centered>
        <ModalBody>
        <div className="table-responsive">
          <table className="table table-striped m-b-0">
            <tbody>
              <tr>
                <th>Nama</th>
                <th>{dataAsset?.name}</th>
              </tr>
              <tr>
                <td>Serial Number</td>
                <td>{dataAsset?.serialNumber}</td>
              </tr>
              <tr>
                <td>Kategori</td>
                <td>{dataAsset?.categoryName}</td>
              </tr>
              <tr>
                <td>Tahun</td>
                <td>{dataAsset?.year}</td>
              </tr>
            </tbody>
          </table>
        </div>
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-white" onClick={() => this.toggleModalDetail()}>Tutup</button>
        </ModalFooter>
      </Modal>
    )
  }

  clickedOutside = (evt) =>{
    const coords = { x: evt.nativeEvent.layerX, y: evt.nativeEvent.layerY };
    // console.log('coords', coords);
    // console.log('event', evt);
    const payload = {
      layoutId: this.state.layoutId,
      assetId: this.state.assetId,
      coords: [coords.x, coords.y, 10]
    };

    if(this.props.setLoading){
      this.props.setLoading(true);
    }
    
    Services.putAssetToLayout(payload)
      .then(res => {
        this.getLayoutAssetCoordinates(payload.layoutId, payload.assetId);
      })
      .catch(err => console.log(err));

    // this.setState({
    //   msg: `You clicked on the image at coords ${JSON.stringify(coords)} !`,
    // });
  };

  clicked = (area) => {
    this.toggleModalDetail(area.id);
    // this.setState({
    //   msg: `You clicked on ${area.shape} at coords ${JSON.stringify(
    //     area.coords
    //   )} !`
    // });
  };

  enterArea = (area) => {
    this.setState({
      canClick: true,
      hoveredArea: area,
      // msg: `You entered ${area.shape} ${area.name} at coords ${JSON.stringify(area.coords)} !`
    });
  };

  leaveArea = (area) => {
    this.setState({
      canClick: false,
      hoveredArea: null,
      // msg: `You leaved ${area.shape} ${area.name} at coords ${JSON.stringify( area.coords)} !`
    });
  };

  getTipPosition = (area) => {
    return { top: `${area.center[1] + (-20)}px`, left: `${area.center[0] + 20}px` };
  };

  handleZoom = (type) => {
    const { zoom } = this.state;
    if (zoom <= this.minWidth && type === 'out') return;
    this.setState({
      zoom: type === 'in' ? zoom + this.zoomWidth : zoom - this.zoomWidth 
    })
  };

  render(){
    if(!this.state.error){
      return(
        <>
          <Panel className={this.state.layoutLoading ? 'panel-loading':''}>
            {this.state.layoutLoading && (
              <div className="panel-loader">
                <span className="spinner-small"></span>
              </div>
            )}
            {(this.state.selectedLayout && !this.state.layoutLoading) &&
              (
              <>
                {!this.props.canChoose && (
                  <>
                    <button className="btn btn-xs btn-gray m-r-5" onClick={() => this.handleZoom('in')}><i className="fa fa-search-plus"/> Zoom In</button>
                    <button className="btn btn-xs btn-gray" onClick={() => this.handleZoom('out')}><i className="fa fa-search-minus"/> Zoom Out</button>
                  </>
                )}
                <div 
                  className='border overflow-auto vh-100 m-t-5' 
                  id="map-layout-asset" 
                  style={{maxWidth:'1002px', maxHeight: '768px', cursor: (this.state.canClick || this.props.canChoose) ? 'pointer': 'default'}}
                  data-for='layout-asset-tooltip'
                  data-tip={''}
                >
                  <ImageMapper
                    src={`${BASE_URL}/layout-zone-file/${this.state.selectedLayout.file}`}
                    map={{name: "map-layout", areas: this.state.mapAreas}}
                    width={this.state.zoom}
                    imgWidth={1000}
                    // responsive
                    // parentWidth={this.state.zoom}
                    onClick={area => this.clicked(area)}
                    onImageClick={(evt) => this.props.canChoose && this.clickedOutside(evt)}
                    onMouseEnter={area => this.enterArea(area)}
                    onMouseLeave={area => this.leaveArea(area)}
                  />
                </div>
                <ReactTooltip id="layout-asset-tooltip" getContent={() => (this.state.hoveredArea ? this.state.hoveredArea.name : null)}/>
                {/* <pre className="message">
                  {this.state.msg ? this.state.msg : null}
                </pre> */}
              </>
              )
            }
          </Panel>
          {this.state.showModalDetail &&
            this.renderModalDetail()
          }
        </>
      )
    }else{
      return(
        <h4>Oops, something went wrong.</h4>
      )
    }
  }
}

export default LayoutMapper;